import { TabItem, Tabs } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

import usePermissions from "hooks/usePermission";
import { Dashboard, DashboardStandard } from ".";

const DashboardTab = () => {
  const [canReadStandard, canReadCustomized] = usePermissions([
    "dashboard:read-standard",
    "dashboard:read",
  ]);
  return (
    <Tabs>
      {canReadStandard && (
        <TabItem title={strings.dashboardStandard}>
          <div className="m-4">
            <DashboardStandard />
          </div>
        </TabItem>
      )}
      {canReadCustomized && (
        <TabItem title={strings.dashboard}>
          <div className="m-4">
            <Dashboard />
          </div>
        </TabItem>
      )}
    </Tabs>
  );
};

const strings = new LocalizedStrings({
  es: {
    dashboardStandard: "Estándar",
    dashboard: "Personalizados",
  },
});

export default DashboardTab;
